// src/pages/sales-order/tabs/InvoiceTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function InvoiceTab({
    fields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <SectionGrid
            fields={fields}
            formData={formData}
            errors={errors}
            onChange={onChange}
            readOnly={readOnly}
            idPrefix="invoice"
            getInputTypeForField={getInputTypeForField}
            getValueForField={getValueForField}
        />
    );
}
